import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import Container from "@material-ui/core/Container";
import Card from '@material-ui/core/Card';
import {Button, CardActions, CardContent, Typography} from "@material-ui/core";
import {ArrowForwardIos, InfoOutlined, KeyboardArrowUp} from '@material-ui/icons';
import {HOME_OVERVIEW_PAGE_PATH, SHIPMENT_TRACKING_PAGE_PATH} from "../../layouts/navigation/Navigator";
import CommonShipmentsComponents, { CommonShipmentsSearchParametersProps } from '../core/shipments/CommonShipmentsComponents';
import SearchField from '../form/SearchFiled';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: 1,
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center"
        },
        card: {
            marginTop: 10,
            "& .MuiCardContent-root": {
                display: "flex",
                flex: 1,
                alignItems: "center",
                "& .MuiSvgIcon-root": {
                    marginRight: 10
                }
            }
        },
        upArrow: {
            flex: 1,
            display: "flex",
            justifyContent: "center",
            "& .MuiSvgIcon-root": {
                height: 80,
                width: 80
            }
        }
    }),
);



const ShipmentTrackingPageComponents = ({initQuery, initLoad, initScroll}: CommonShipmentsSearchParametersProps) => {

    const classes = useStyles();

    const [showShipments, setShowShipments] = React.useState<Boolean>(initLoad !== undefined && initLoad > 0);
    const [searchQuery, setSearchQuery] = React.useState(initQuery);

    const executeSearch = () => {
        setShowShipments(true);
    };

    if (showShipments) {
        return <CommonShipmentsComponents detailsPagePath={SHIPMENT_TRACKING_PAGE_PATH} Icon={<ArrowForwardIos/>}
                                          initQuery={searchQuery} initLoad={initLoad} initScroll={initScroll}/>
    }

    return (<div className={classes.root}>

            <Container maxWidth="xs">
                <SearchField searchQuery={searchQuery} setSearchQuery={setSearchQuery}
                             executeSearch={executeSearch}/>
            </Container>

            <InfoCard executeSearch={executeSearch}/>

        </div>
    );
};

type InfoCardProps = {
    executeSearch: (evt) => void
};

export const InfoCard: React.FC<InfoCardProps> = ({executeSearch}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    return <Container maxWidth="xs">
        <UpArrow/>
        <Card className={classes.card}>
            <CardContent>
                <InfoOutlined/>
                <Typography variant="body2" component="p">
                    {t("shipment.info-search")}
                </Typography>
            </CardContent>
            <CardActions>
                <Button variant="contained" color="primary" size="small"
                        onClick={executeSearch}
                        fullWidth={true}>{t("shipment.view-all-button")}</Button>
            </CardActions>
        </Card>

        <Card className={classes.card}>
            <CardContent>
                <InfoOutlined/>
                <Typography variant="body2" component="p">
                    {t("shipment.note-search")}
                </Typography>
            </CardContent>
            <CardActions>
                <Button href={HOME_OVERVIEW_PAGE_PATH} variant="contained" size="small"
                        fullWidth={true}>{t("core.close")}</Button>
            </CardActions>
        </Card>

    </Container>
};

export const UpArrow = () => {
    const classes = useStyles();
    return <div className={classes.upArrow}>
        <KeyboardArrowUp/>
    </div>
};

export default ShipmentTrackingPageComponents;